import { render, staticRenderFns } from "./contacto-asistencia.vue?vue&type=template&id=b0ff10f6&"
import script from "./contacto-asistencia.component.ts?vue&type=script&lang=ts&"
export * from "./contacto-asistencia.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports